{
	"showButtonTitle": "Zobrazit",
	"hideButtonTitle": "Skrýt"
}
